// extracted by mini-css-extract-plugin
export default {"resourcesPageResources":"ResourcesList_resourcesPageResources__beNkb","resourcesWrapperResources":"ResourcesList_resourcesWrapperResources__WYM9T"};